<template>
    <div class="google-map" :id="mapName"></div>
</template>

<script>
    /*global google*/

    export default {
        name: 'google-map',
        props: ['name'],

        data: function () {
            return {
                markers: [],
                polygons: [],

                mapName: this.name + "-map",
                center: { lat: -34.6036844, lng: -58.3815591 }
            }
        },

        mounted: function () {
            const element = document.getElementById(this.mapName);

            this.map = new google.maps.Map(element, {
                zoom: 16,
                center: new google.maps.LatLng(this.center.lat, this.center.lng),
                disableDefaultUI: true
            });

            this.geocoder = new google.maps.Geocoder();
            this.places = new google.maps.places.PlacesService(this.map);
        },

        methods: {
            setCenter(loc) {
                this.map.setCenter(loc);
                this.map.setZoom(14);
            },

            setMarker(loc) {
                let marker = new google.maps.Marker({
                    map: this.map,
                    position: loc
                });
                this.markers.push(marker);
            },

            clearMarkers() {
                for(let m of this.markers) {
                    m.setMap(null);
                }
                this.markers = [];
            },

            addPolygon(data) {
                let polygon = new google.maps.Polygon(data);
                polygon.setMap(this.map);

                this.polygons.push(polygon);
            },

            clearPolygons() {
                for(let p of this.polygons) {
                    p.setMap(null);
                }
                this.polygons = [];
            },

            getBounds(polygon) {
                let bounds = new google.maps.LatLngBounds();
                let paths = polygon.getPaths();
                let path;
                for (let i = 0; i < paths.getLength(); i++) {
                    path = paths.getAt(i);
                    for (let ii = 0; ii < path.getLength(); ii++) {
                        bounds.extend(path.getAt(ii));
                    }
                }
                return bounds;
            },

            getAddressInfo(params) {
                return new Promise((resolve, reject) => {
                    this.geocoder.geocode(params, (results, status) => {
                        if(status !== 'OK') {
                            return reject();
                        }

                        return resolve(results[0]);
                    });
                });
            },

            getPlaceDetails(id) {
                return new Promise((resolve, reject) => {
                    this.places.getDetails({
                        placeId: id,
                        fields: ['name', 'geometry', 'type']
                    }, (place, status) => {
                        if(status === 'OK')
                            return resolve(place);
                        else
                            return reject();
                    });
                });
            }
        }
    };
</script>

<style lang="scss" scoped>
    .google-map {
        margin: 0 auto;
        background: gray;
    }
</style>